import { faEye, faFile } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DataGrid, { Column, Pager, Paging, Scrolling, SearchPanel, Summary, TotalItem } from 'devextreme-react/cjs/data-grid';
import useHasPermission from 'hooks/useHasPermission';
import React, { useState } from 'react'
import { Card } from 'react-bootstrap';
import CustomStore from 'devextreme/data/custom_store';
import { getPoProductDocByinvoiceNo, getPoProductList } from './services/po.order.service';
import POdetails from './components/POdetails';
import notistack from 'pages/Core/Notistack';
import { HttpStatus } from 'pages/Core';
import PdfViewerModal from './components/PdfViewerModal';
import Loader from 'Common/Loader';

const POordersList = () => {

    const HasPermission = useHasPermission()

    const [isViewModalOpen, setIsViewModalOpen] = useState(false)
    const [isDocumentModalOpen, setIsDocumentModalOpen] = useState(false)
    const [loading, setLoading] = useState(false)

    const [selectedId, setSelectedId] = useState<number>()
    const [pdfBase64, setPdfBase64] = useState<string | null>(null)

    const dataSource = (): any | undefined => {
        return new CustomStore({
            key: "id",
            load: async (loadOptions) => {
                try {

                    const { searchValue, skip, take } = loadOptions;

                    const parameterList = new URLSearchParams();

                    if (typeof skip === 'number') parameterList.append('skip', skip.toString());
                    if (typeof take === 'number') parameterList.append('take', take.toString());

                    const search = JSON.parse(JSON.stringify(loadOptions));

                    for (const [key, value] of Object.entries(search)) {
                        parameterList.append(key, JSON.stringify(value));
                    }

                    if (searchValue) {
                        parameterList.append("search", searchValue);
                    }

                    const response = await getPoProductList(parameterList);

                    return response

                } catch (error) {

                    console.error("Data loading error:", error);

                    return { data: [], totalCount: 0 };
                }
            },
        });
    };

    const getPoProductDoc = async (invoiceNo: any) => {

        try {
            setLoading(true)
            setPdfBase64(null)

            const response = await getPoProductDocByinvoiceNo({ invoiceNo })

            if (response.status === HttpStatus.Success) {

                setPdfBase64(response?.data?.data)

                setIsDocumentModalOpen(true)
            }

        } catch (error: any) {

            notistack.error(error)
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            {loading && <Loader />}
            <div className="page-content">
                <div className="container-fluid">

                    <Card>

                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <h5 className="m-0" >PO Orders</h5>
                        </Card.Header>

                        <Card.Body>

                            {HasPermission("Customer.Read") ? (

                                <DataGrid
                                    dataSource={dataSource()}
                                    remoteOperations={{ groupPaging: true }}
                                    showRowLines={true}
                                    keyExpr="id"
                                    showBorders={true}
                                    columnAutoWidth
                                    onContentReady={(e) => {
                                        const hasData = e.component.totalCount() > 0;
                                        e.component.option("pager.visible", hasData);
                                        e.component.option("paging.visible", hasData);
                                    }}
                                >

                                    <Pager
                                        showPageSizeSelector
                                        allowedPageSizes={[10, 25, 50, 100]}
                                        showNavigationButtons
                                        displayMode="full"
                                        showInfo
                                    />

                                    <Scrolling
                                        mode="standard"
                                        useNative={true}
                                        scrollByContent={true}
                                        scrollByThumb={true}
                                    />

                                    <SearchPanel
                                        visible={true}
                                        width={240}
                                        placeholder="Search..."
                                    />

                                    <Summary>
                                        <TotalItem />
                                    </Summary>

                                    <Paging defaultPageSize={10} />

                                    <Column
                                        dataField="id"
                                        dataType="number"
                                        sortOrder="desc"
                                        width={150}
                                        visible={false}
                                    />

                                    <Column
                                        allowFiltering={false}
                                        caption="Action"
                                        cssClass="text-center"
                                        width={120}
                                        cellRender={({ data }) => (

                                            <div className="d-flex justify-content-center align-items-center gap-2">

                                                <button
                                                    className='btn btn-sm action-btn'
                                                    title='View Details'
                                                    onClick={() => {
                                                        setSelectedId(data?.id)
                                                        setIsViewModalOpen(true)
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faEye} className="ml-2" />
                                                </button>

                                                <button
                                                    className='btn btn-sm action-btn'
                                                    title='View Document'
                                                    onClick={() => {
                                                        getPoProductDoc(data?.poInvoiceNo)
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faFile} className="ml-2" />
                                                </button>

                                            </div>
                                        )}
                                    />

                                    <Column
                                        dataField="vendor"
                                        caption="Vendor Name"
                                        width={150}
                                    />

                                    <Column
                                        dataField="poInvoiceNo"
                                        caption="Invoice No."
                                        width={200}
                                    />

                                    <Column
                                        dataField="productHeaderItemMaster"
                                        caption="Product Name"
                                        width={150}
                                    />

                                    <Column
                                        dataField="styleNo"
                                        caption="Style No"
                                        width={150}
                                    />

                                    <Column
                                        dataField="materialType"
                                        caption="Material Type"
                                        width={150}
                                    />

                                    <Column
                                        dataField="quntity"
                                        caption="Quantity"
                                        width={100}
                                    />

                                    <Column
                                        dataField="category"
                                        caption="Category"
                                        width={150}
                                    />

                                    {/* <Column
                                        dataField="poDate"
                                        caption="PO Date"
                                        width={140}
                                        dataType="date"
                                        format="dd/MM/yyyy"
                                    /> */}

                                </DataGrid>

                            ) : (
                                null
                            )}

                        </Card.Body>

                    </Card>

                </div>
            </div>

            <POdetails
                selectedId={selectedId}
                onClose={() => {
                    setIsViewModalOpen(false)
                    setSelectedId(undefined)
                }}
                isViewModalOpen={isViewModalOpen}
            />

            <PdfViewerModal
                visible={isDocumentModalOpen}
                base64Data={pdfBase64}
                title="PO Document"
                onClose={() => {
                    setIsDocumentModalOpen(false)
                    setPdfBase64(null)
                }}
            />
        </>
    )
}

export default POordersList